import { FC } from "react";

interface AppleStoreSVGStoreSVGProps {
    width?: number;
    height?: number;
}

const AppleStoreSVG: FC<AppleStoreSVGStoreSVGProps> = ({
    width = 24,
    height = 24,
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <circle
                cx="12"
                cy="12"
                r="11.7"
                fill="white"
                stroke="#00086D"
                stroke-width="0.6"
            />
            <path
                d="M13.5556 5L8.11111 14.1765M8.11111 14.1765H5M8.11111 14.1765H12.7778M5.77778 18L6.55556 16.7255M15.7059 14.1765L18.2222 18M15.7059 14.1765H19M15.7059 14.1765L13.1895 10.3529M9.66667 5L11.6797 8.05882"
                stroke="#00086D"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default AppleStoreSVG;
